export enum LeaveTypeCodes {
  ANNUAL_LEAVE = 1,
  EMERGENCY_LEAVE = 2,
  SICK_LEAVE = 3,
}
